import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function DestinationCard({ d, idx, className }) {
  return (
    <Link
      to={`/destinations#${d.slug}`}
      data-testid={HOME.destinationCard(d.slug)}
      className={`group relative img-zoom block ${className} overflow-hidden`}
    >
      <img
        src={d.hero}
        alt={d.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10" />
      <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-end">
        <div className="eyebrow-light mb-4">Chapter 0{idx + 1}</div>
        <div className="font-serif text-5xl md:text-7xl text-ivory font-light leading-none">
          {d.name}
        </div>
        <div className="mt-5 max-w-md text-ivory/95 text-sm md:text-base font-light leading-relaxed">
          {d.tagline}
        </div>
        <div className="mt-6 inline-flex items-center gap-2 text-goldleaf text-[11px] tracking-widest2 uppercase font-semibold">
          Discover
          <ArrowUpRight
            size={14}
            className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </div>
      </div>
    </Link>
  );
}
